import {
  type RouteObject,
} from "react-router";
import WordTemplateDetailApp from "WordTemplate/detail/app";
import WordTemplateListApp from "WordTemplate/list/app";
import WordTemplateNewApp from "WordTemplate/new/app";

declare let viewModel: any;

export const wordTemplateRoute: RouteObject = {
  path: "wordtemplate",
  children: [{
    path : ":mainArea",
    loader: () => viewModel,
    Component: WordTemplateListApp,
  }, {
    path: "detail/:key",
    loader: () => viewModel,
    Component: WordTemplateDetailApp,
  }, {
    path: ":mainArea/new",
    loader: () => viewModel,
    Component: WordTemplateNewApp,
  }]
};